export default "/fonts/vendor/katex/dist/KaTeX_Caligraphic-Bold.woff2?a1abf90dfd72792a577a5a43382bb0e4";